import {
  getTransactionByIdService,
  getTransactionsService,
  getTransactionsStatsService,
} from "@/services/transactions.service";
import type {TransactionStatus, TransactionType} from "@/types/transaction.types";
import {useQuery} from "@tanstack/react-query";

const TRANSACTIONS_KEY = ["transactions"] as const;
const TRANSACTIONS_STATS_KEY = ["transactions", "stats"] as const;

interface TransactionsFilters {
  page?: number;
  limit?: number;
  search?: string;
  type?: TransactionType | "all";
  status?: TransactionStatus | "all";
  userId?: string;
  from?: string;
  to?: string;
}

export const useTransactions = (filters: TransactionsFilters = {}) =>
  useQuery({
    queryKey: [...TRANSACTIONS_KEY, filters],
    queryFn: async () => {
      const {data} = await getTransactionsService(filters);
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });

export const useTransaction = (id: string) =>
  useQuery({
    queryKey: [...TRANSACTIONS_KEY, id],
    queryFn: async () => {
      const {data} = await getTransactionByIdService(id);
      if (data === undefined) throw new Error("No data");
      return data;
    },
    enabled: !!id,
  });

export const useTransactionsStats = () =>
  useQuery({
    queryKey: TRANSACTIONS_STATS_KEY,
    queryFn: async () => {
      const {data} = await getTransactionsStatsService();
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });
